/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { findAll10 } from '../fn/week-template-type/find-all-10';
import { FindAll10$Params } from '../fn/week-template-type/find-all-10';
import { WeekTemplateType } from '../models/week-template-type';

@Injectable({ providedIn: 'root' })
export class WeekTemplateTypeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `findAll10()` */
  static readonly FindAll10Path = '/api/values/app-weektemplatetypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findAll10()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAll10$Response(params?: FindAll10$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WeekTemplateType>>> {
    return findAll10(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findAll10$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAll10(params?: FindAll10$Params, context?: HttpContext): Observable<Array<WeekTemplateType>> {
    return this.findAll10$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WeekTemplateType>>): Array<WeekTemplateType> => r.body)
    );
  }

}
